import React from 'react';
import '../styles/whySynectiks.css';

const WhySynectiks = () => {
    const advantages = [
        {
            title: "Deep Specialization",
            desc: "Expertise in Microsoft 365, Entra ID, and Purview to secure your core identity and data."
        },
        {
            title: "Proven Transformation",
            desc: "Extensive experience delivering secure, high-impact workplace modernizations for enterprises."
        },
        {
            title: "Governance-Led AI",
            desc: "Our frameworks ensure AI adoption is intentional, compliant, and risk-aware from day one."
        },
        {
            title: "Enterprise Discipline",
            desc: "Fast, responsive delivery models built to meet the rigorous standards of modern business."
        }
    ];

    return (
        <section className="why-section">
            <div className="why-container">
                <div className="why-info">
                    <span className="badge">The Synectiks Advantage</span>
                    <h2 className="why-heading">Organizations choose us for Microsoft expertise & security-first execution</h2>
                    <p className="why-text">
                        As a trusted Microsoft Solutions Partner, we help customers move from 
                        <strong> “AI-enabled”</strong> to <strong>AI operationalized.</strong>
                    </p>
                </div>

                <div className="why-grid">
                    {advantages.map((item, index) => (
                        <div className="advantage-card" key={index}>
                            {/* <div className="card-accent"></div> */}
                            <h4 className="advantage-title">{item.title}</h4>
                            <p className="advantage-desc">{item.desc}</p>
                        </div>
                    ))}
                    
                    <div className="outcome-card">
                        <div className="outcome-content">
                            <h3>Outcome Focused</h3>
                            <p>We measure success by your business impact, not just the technical implementation.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhySynectiks;